import { Link, usePage } from '@inertiajs/react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useRouter } from '../router';
import { Charity, PageProps } from '../types';
import Container from '../UI/Container';
import Header from '../UI/Header';
import HeaderTitle from '../UI/HeaderTitle';
import { tabClasses } from '../UI/helpers';

export function CharitySettingsLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { component, props: { charity } } = usePage<PageProps>();

  return (
    <>
      <CharitySettingsHeader charity={charity} component={component} />
      {children}
    </>
  );
}

export function CharitySettingsHeader({
  charity,
  component,
}: {
  charity: Charity;
  component: string;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  return (
    <Header>
      <Container className="!pb-0 text-center">
        <HeaderTitle className="justify-center">
          {t('backend:organisation')}
        </HeaderTitle>

        <div className="mt-2 space-x-4">
          <Link
            href={routes.charity_settings_page()}
            className={tabClasses({ active: component === 'Backend/Charity/CharitySettingsPage' })}
          >
            {t('backend:general')}
          </Link>
          <Link
            href={routes.mail_settings_page()}
            className={tabClasses({ active: component === 'Backend/Charity/MailSettingsPage' })}
          >
            {t('backend:mail')}
          </Link>
          <Link
            href={routes.event_settings_page()}
            className={tabClasses({ active: component === 'Backend/Charity/EventSettingsPage' })}
          >
            {t('backend:events')}
          </Link>
          <Link
            href={routes.integrations_page()}
            className={tabClasses({ active: component === 'Backend/Charity/IntegrationsPage' })}
          >
            {t('backend:integrations')}
          </Link>
          {charity.has_subscriptions && (
            <Link
              href={routes.invoices_page()}
              className={tabClasses({ active: component === 'Backend/Charity/InvoicesPage' })}
            >
              {t('backend:invoices')}
            </Link>
          )}
        </div>
      </Container>
    </Header>
  );
}
